import script from "./SideNav.vue?vue&type=script&setup=true&lang=js"
export * from "./SideNav.vue?vue&type=script&setup=true&lang=js"

import "./SideNav.vue?vue&type=style&index=0&id=9c018bd2&lang=scss"

const __exports__ = script;

export default __exports__